import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-new-card',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-new-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonNewCardComponent { }
